"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CuratorsPage = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireWildcard(require("react"));
var _speakerCard = require("../../speakerCard");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _featureToggles = _interopRequireDefault(require("../../../utils/featureToggles"));
var _comingSoonPage = _interopRequireDefault(require("../comingSoonPage"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CuratorsPage = props => {
  const {
    comingSoon,
    curatorsList,
    t
  } = props;
  const thumbnailDirectory = '/assets/images/curators/thumbnails/';
  const renderCuratorsCards = () => {
    return /*#__PURE__*/_react.default.createElement("ul", {
      className: "con-list"
    }, curatorsList.map(item => {
      return /*#__PURE__*/_react.default.createElement(_speakerCard.SpeakerCard, {
        speakerId: item.speakerId,
        key: item.speakerId,
        imageUrl: thumbnailDirectory + item.image,
        name: item.name,
        jobTitle: item.jobTitle,
        description: item.description
      });
    }));
  };
  (0, _react.useEffect)(() => {
    document.title = t('Pages.Curators.Title');
    // TO DO: fetch speaker data
    if (!curatorsList) {
      setCurators(curators);
    }
  }, []);
  if (_featureToggles.default.curatorsComingSoon()) {
    return /*#__PURE__*/_react.default.createElement(_comingSoonPage.default, {
      title: t('Pages.Curators.Title'),
      header: t('Pages.Curators.Header')
    });
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "con-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-flex__container"
  }, /*#__PURE__*/_react.default.createElement("h1", {
    className: "con-heading aicon-heading__l--margin-bottom-3"
  }, t('Pages.Curators.Header'))), renderCuratorsCards()));
};
exports.CuratorsPage = CuratorsPage;
CuratorsPage.propTypes = {
  curatorsList: _propTypes.default.array,
  t: _propTypes.default.func
};